import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { EMPTY, Observable } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import { PayloadedAction } from '../../../../shared/types'
import { AAAStore } from '../../../../store/root-reducer'
import { completeReviews, REVIEWS_LOAD } from './review.actions'
import { ReviewService } from './review.service'
import { ReviewPagination } from './review.types'

@Injectable()
export class ReviewEffects {
  constructor(
    private actions$: Actions,
    private store$: Store<AAAStore>,
    private reviewService: ReviewService,
  ) { }

  loadReviews$ = createEffect(
    (): Observable<
      | ReturnType<typeof completeReviews>
    > =>
      this.actions$.pipe(
        ofType(REVIEWS_LOAD.REQUEST),
        switchMap((action: PayloadedAction<string>) =>
          this.reviewService.getReviews$(action.payload, { limit: 5 }).pipe(
            map((reviewPagination: ReviewPagination) =>
              completeReviews({ payload: reviewPagination })
            ),
            // Reviews are supplementary content on the AAR card and the store has
            // no REVIEWS_LOAD.FAILURE branch, so a failed load is logged and
            // swallowed rather than dispatching a failure action.
            catchError((error) => {
              console.error(error)
              return EMPTY
            })
          )
        )
      )
  )
}
